import React, {Fragment} from 'react';
 import PageTitle from '../../components/pagetitle'
import BlogSingle from '../../components/BlogDetails'
import Scrollbar from '../../components/scrollbar'
import Footer from '../../components/footer';
import Logo from '../../images/logo.svg'
import Navbar2 from '../../components/Navbar2';
import { useParams } from 'react-router-dom'
const BlogDetailsFull =() => {
  
  const { id } = useParams()
    return(
        <Fragment>
            <Navbar2 Logo={Logo} hclass={'wpo-header-style-3'}/>
            <PageTitle pageTitle={`${id=="politique-de-confidentialite" ? "Politique de Confidentialité" :"Termes et Conditions d'Utilisation" }`} pagesub={'Page'}/> 
            <BlogSingle blLeft={'d-none'} blRight={'col-lg-10 offset-lg-1'}/>
            <Footer ftClass={'wpo-site-footer-s2'}/>
            <Scrollbar/>
        </Fragment>
    )
};
export default BlogDetailsFull;